export const REQ_TYPE = {
  post: 'post',
  get: 'get',
  put: 'put',
  delete: 'delete'
}
